
import { Injectable } from '@angular/core';
import { FilterStateServiceBase } from '@services/filter-state.service.base';
import { IFilterBar } from '@shared/models/interfaces';

const PATIENT_DEFAULTS: IFilterBar = {
  search: '',
  sort: 'Last Modified',
  filter: '',
  searchBy: 'First Name',
  direction: 'desc',
};

@Injectable({ providedIn: 'root' })
export class PatientStateService extends FilterStateServiceBase {
  constructor() {
    super({
      storageNamespace: 'patient',
      defaultState: PATIENT_DEFAULTS,
    });
  }
}
